var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.43 16.7024H11.3325C8.00251 16.7024 6.39751 15.3899 6.12001 12.4499C6.09001 12.1424 6.31501 11.8649 6.63001 11.8349C6.93001 11.8049 7.21501 12.0374 7.24501 12.3449C7.46251 14.6999 8.57251 15.5774 11.34 15.5774H11.4375C14.49 15.5774 15.57 14.4974 15.57 11.4449V6.55486C15.57 3.50236 14.49 2.42236 11.4375 2.42236H11.34C8.55751 2.42236 7.44751 3.31486 7.24501 5.71486C7.20751 6.02236 6.94501 6.25486 6.63001 6.22486C6.31501 6.20236 6.09001 5.92486 6.11251 5.61736C6.36751 2.63236 7.98001 1.29736 11.3325 1.29736H11.43C15.1125 1.29736 16.6875 2.87236 16.6875 6.55486V11.4449C16.6875 15.1274 15.1125 16.7024 11.43 16.7024Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.5625H2.71503C2.40753 9.5625 2.15253 9.3075 2.15253 9C2.15253 8.6925 2.40753 8.4375 2.71503 8.4375H11.25C11.5575 8.4375 11.8125 8.6925 11.8125 9C11.8125 9.3075 11.5575 9.5625 11.25 9.5625Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.38752 12.0749C4.24502 12.0749 4.10252 12.0224 3.99002 11.9099L1.47752 9.39738C1.26002 9.17988 1.26002 8.81988 1.47752 8.60238L3.99002 6.08988C4.20752 5.87238 4.56752 5.87238 4.78502 6.08988C5.00252 6.30738 5.00252 6.66738 4.78502 6.88488L2.67002 8.99988L4.78502 11.1149C5.00252 11.3324 5.00252 11.6924 4.78502 11.9099C4.68002 12.0224 4.53002 12.0749 4.38752 12.0749Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.72e407ba04fb33e508da7fc1be4cfe3a.svg";
export { ForwardRef as ReactComponent };